import"./AutoComplete.css.ts.vanilla.css";var e={container:"AutoComplete_styles_container__fmvo1c0",inputWrapper:"AutoComplete_styles_inputWrapper__fmvo1c1",close:"AutoComplete_styles_close__fmvo1c2"};export{e as styles};
//# sourceMappingURL=AutoComplete.css.vanilla.js.map
